import { useEffect, useRef } from 'react';

/**
 * AdBanner Component
 * Displays Google AdSense banner ads
 * 
 * Props:
 * - adSlot: Your ad slot ID from AdSense
 * - className: Additional CSS classes
 */
const AdBanner = ({ 
  adSlot = '8447535141', 
  className = '' 
}) => {
  const adRef = useRef(null);
  const isAdLoaded = useRef(false);

  useEffect(() => {
    // Only load ad once
    if (isAdLoaded.current) return;
    
    try {
      if (window.adsbygoogle && adRef.current) {
        (window.adsbygoogle = window.adsbygoogle || []).push({});
        isAdLoaded.current = true;
      }
    } catch (e) {
      console.error('AdSense error:', e);
    }
  }, []);

  return (
    <div className={`ad-banner-container ${className}`} style={{ minHeight: '100px', marginTop: '2rem', marginBottom: '2rem' }}>
      <ins
        ref={adRef}
        className="adsbygoogle"
        style={{ display: 'block' }}
        data-ad-client="ca-pub-9789426917966477"
        data-ad-slot={adSlot}
        data-ad-format="auto"
        data-full-width-responsive="true"
      />
    </div>
  );
};

export default AdBanner;
